<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">All Student Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Student Data</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright">
                                    Add New Record
                                </button>
                                <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg">
                                    <i class="fe fe-download-cloud me-2"></i> Download Report
                                </button>
                                <button mat-button type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">

                                    <i class="fe fe-filter me-2"></i> Doc Type

                                </button>

                            </div>
                        </div>
                    </div>
                    <!-- End Page Header [formGroup]="FacultyForm"-->

                    <div class="row row-sm add-form">
                        <form autocomplete="off" novalidate class="p-0" [formGroup]="StudentForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="mb-3">
                                            <h3 class="main-content-label mb-1"><b> Add New Student Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0"> Add New Student Information</p>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>Name</mat-label>
                                                            <input class="color" matInput placeholder="Name" formControlName="SName">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>Age</mat-label>
                                                            <input class="color" matInput placeholder="Age" formControlName="SAge">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>Gender</mat-label>
                                                            <input class="color" matInput placeholder="Gender" formControlName="SGender">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div *ngfor="let s of students">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>{{value}}</mat-label>
                                                            <input class="color" matInput formControlName=s.SAddress>
                                                        </mat-form-field>
                                                        <mat-error class="margin_tp" *ngIf="StudentForm.controls['SFax'].touched && StudentForm.controls['SFax'].errors?.required">
                                                            Mandatory Field
                                                        </mat-error>
                                                    </div>
                                                </div>
                                            </div> -->
                                            
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <div *ngFor="let s of studentArr" class="skills-container">
                                                            <div *ngIf="s.Visible" class="skill">
                                                                <mat-form-field class="example-full-width">
                                                                    <mat-label>{{s.display}}</mat-label>
                                                                    <input class="color" matInput [formControlName]="s.form">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                            
                                            <!-- <div class="col-sm-3" *ngIf="showFax">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>{{value}}</mat-label>
                                                            <input class="color" matInput formControlName="SFax">
                                                        </mat-form-field>
                                                        <mat-error class="margin_tp" *ngIf="StudentForm.controls['SFax'].touched && StudentForm.controls['SFax'].errors?.required">
                                                            Mandatory Field
                                                        </mat-error>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3" *ngIf="showAddress">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>{{value1}}</mat-label>
                                                            <input class="color" matInput formControlName="SAddress">
                                                        </mat-form-field>
                                                        <mat-error class="margin_tp" *ngIf="StudentForm.controls['SAddress'].touched && StudentForm.controls['SAddress'].errors?.required">
                                                            Mandatory Field
                                                        </mat-error>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3" *ngIf="showEmail">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field class="example-full-width">
                                                            <mat-label>{{value2}}</mat-label>
                                                            <input class="color" matInput formControlName="SEmail">
                                                        </mat-form-field>
                                                        <mat-error class="margin_tp" *ngIf="StudentForm.controls['SEmail'].touched && StudentForm.controls['SEmail'].errors?.required">
                                                            Mandatory Field
                                                        </mat-error>
                                                    </div>
                                                </div>
                                            </div> -->
                                            
                                        </div>
                                        <button class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base" (click)="back()">Back</button>
                                        <button class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base" (click)="add()">add</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </form>
</body>